module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_015.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_015.png
// module id = 960
// module chunks = 0